const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/api/";
const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL || "http://localhost:8080/ws";
const APP_TITLE = process.env.REACT_APP_TITLE || "EFTA Tuz";
const API_TIMEOUT = Number(process.env.REACT_APP_API_TIMEOUT ?? 10000);

const apiConfig = {
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
};

export { API_BASE_URL, WEBSOCKET_URL, APP_TITLE, API_TIMEOUT };
export default apiConfig;
